/**
 * Удаление лоадера из dom дерева после загрузки страницы
 * Скрипт отрабатывает в любом случае, даже если есть ошибки в JS
 */
window.onload = function () {
  let loader = document.querySelector(".loader");
  loader.parentNode.removeChild(loader);
};

$(document).ready(function () {
  /** Глобальные переменные */
  var WIN = $(window),
    DOC = $(document),
    HTML = $("html");

  /** Определяем браузеры Internet Explorer 11 и Edge */
  let ua = window.navigator.userAgent,
    edge_ua = ua.indexOf("Edge/"),
    ie_ua = ua.indexOf("Trident/7.0"),
    edge = "edge",
    ie = "ie";
  if (edge_ua > 0) {
    HTML.addClass(edge);
  }
  if (ie_ua + 1) {
    HTML.addClass(ie);
  }

  /** Добавляем стили и скрипты для браузера Internet Explorer 11 */
  if (HTML.hasClass(ie)) {
    HTML.append('<script src="../../js/' + ie + '.js"></script>');
    HTML.append('<link href="../../css/' + ie + '.css" rel="stylesheet">');
  }

  // function setServerTimerBonusHeader(selector) {
  //     let serverTimers = selector
  //     if (serverTimers.length) {
  //         const timer = CountdownTimer.getInstance();
  //         serverTimers.each((_, el) => {
  //             const observer = new CountdownTimerObserver(el, (timerData) => {
  //                 return `
  //                     <div class="counter__block">${timerData.days} d
  //                     </div>
  //                     <div class="counter__block">${timerData.hours} h
  //                     </div>
  //                     <div class="counter__block">${timerData.minutes} m
  //                     </div>
  //                     <div class="counter__block">${timerData.seconds} s
  //                     </div>
  //                     `
  //             });
  //             timer.attach(observer);
  //         });
  //         timer.start();
  //     }
  // }
  // setServerTimerBonusHeader($('[data-time-bonus-header]'))

  /** Input animation **/

  function inputAnimation() {
    if ($(".input").length) {
      const AUTOFILLED = "is-autofilled";
      const onAutoFillStart = (el) => el.classList.add(AUTOFILLED);
      const onAutoFillCancel = (el) => el.classList.remove(AUTOFILLED);
      const onAnimationStart = ({ target, animationName }) => {
        switch (animationName) {
          case "onAutoFillStart":
            return onAutoFillStart(target);
          case "onAutoFillCancel":
            return onAutoFillCancel(target);
        }
      };

      document
        .querySelector(".input")
        .addEventListener("animationstart", onAnimationStart, false);

      setTimeout(function () {
        $(".input").each(function () {
          if ($(".input").hasClass("is-autofilled")) {
            $(this).parent().addClass("animation");
          }
        });
      }, 100);
    }

    $(".input").each(function () {
      if ($(this).val() != "") {
        $(this).parent().addClass("animation");
      }
    });

    //Add animation when input is focused
    $(".input").focus(function () {
      $(this).parent().addClass("animation animation-color");
    });

    //Remove animation(s) when input is no longer focused
    $(".input").focusout(function () {
      if ($(this).val() === "") {
        $(this).parent().removeClass("animation");
        $(this).parent().removeClass("animation-color");
      }
    });
  }

  inputAnimation();

  /** End **/

  // Серверный таймер для турнира
  let serverTimers = $("[data-server-timer]");
  if (serverTimers.length) {
    const timer = CountdownTimer.getInstance();
    serverTimers.each((_, el) => {
      const observer = new CountdownTimerObserver(el, (timerData) => {
        return `
                <div class="counter__block">
                <span class="counter__value">${timerData.days}</span>
                <span class="counter__desc">
                ${timerData.daysLabel}
                </span>
                </div>
                <dl>:</dl>
                <div class="counter__block">
                <span class="counter__value">${timerData.hours}</span>
                <span class="counter__desc">
                ${timerData.hoursLabel}
                </span>
                </div>
                <dl>:</dl>
                <div class="counter__block">
                <span class="counter__value">${timerData.minutes}</span>
                <span class="counter__desc">
                ${timerData.minutesLabel}
                </span>
                </div>
                <dl>:</dl>
                <div class="counter__block">
                <span class="counter__value">${timerData.seconds}</span>
                <span class="counter__desc">
                ${timerData.secondsLabel}
                </span>
                </div>
                `;
      });
      timer.attach(observer);
    });
    timer.start();
  }

  // Серверный таймер в хэдэре для бонуса
  serverTimers = $("[data-time-bonus-header]");
  if (serverTimers.length) {
    const timer = CountdownTimer.getInstance();
    serverTimers.each((_, el) => {
      const observer = new CountdownTimerObserver(el, (timerData) => {
        return `
                        <div class="counter__block">${timerData.days}d
                        </div>
                        <div class="counter__block">${timerData.hours}h
                        </div>
                        <div class="counter__block">${timerData.minutes}m
                        </div>
                        <div class="counter__block">${timerData.seconds}s
                        </div>
                        `;
      });
      timer.attach(observer);
    });
    timer.start();
  }
  /** Мобильное меню **/

  function mobileMenu() {
    let opener = $("[data-mobile-menu]");
    let wrapper = $("[data-mobile-wrapper]");
    let closer = $("[data-mobile-menu-closer]");
    opener.on("click", function (e) {
      e.preventDefault();
      let that = $(e.target);
      if (!that.hasClass("close")) {
        wrapper.addClass("opened");
      } else {
        wrapper.removeClass("opened");
      }
    });
    closer.on("click", function (e) {
      e.preventDefault();
      wrapper.removeClass("opened");
    });
  }

  mobileMenu();

  // DOC.on('click', '.mobile-wrapper', function() {
  // 	console.log('click');
  // 	$('[data-mobile-wrapper]').removeClass('opened');
  // });

  DOC.on("click", "[data-mobile-wrapper]", function (e) {
    var mobmenu_wrapper = $("[data-mobile-wrapper]");
    if (mobmenu_wrapper.hasClass("opened")) {
      if (!$(e.target).closest(".mobile-wrapper__content").length) {
        mobmenu_wrapper.removeClass("opened");
      }
      e.stopPropagation();
    }
  });

  // detecting vertical and horizontal resize and using only horizontal to close burger menu
  (function () {
    var win = jQuery(window),
      prev_width = win.width(),
      prev_height = win.height();
    win.on("resize", function () {
      var width = win.width(),
        height = win.height();

      if (width !== prev_width) {
        win.trigger("hresize");
      }
      if (height !== prev_height) {
        win.trigger("vresize");
      }

      prev_width = width;
      prev_height = height;
    });
  })();

  WIN.on("hresize", function () {
    $(".mobile-wrapper.opened").each(function () {
      $(".mobile-wrapper.opened").removeClass("opened");
    });
  });

  window.addEventListener(
    "orientationchange",
    function () {
      $(".mobile-wrapper.opened").each(function () {
        $(".mobile-wrapper.opened").removeClass("opened");
      });
    },
    false
  );

  function mobileMenuUser() {
    let opener = $("[data-mobile-menu-user], .user-info__profile-name--mobile");
    let wrapper = $("[data-mobile-wrapper-user]");
    let closer = $("[data-mobile-menu-closer]");

    opener.on("click", function (e) {
      e.preventDefault();
      let that = $(e.target);
      if (!that.hasClass("close")) {
        wrapper.addClass("opened");
      } else {
        wrapper.removeClass("opened");
      }
    });
    closer.on("click", function (e) {
      e.preventDefault();
      wrapper.removeClass("opened");
    });

    // opener.each(() => {
    //     opener.on('click', function(e){
    //         e.preventDefault();
    //         let that = $(e.target);
    //         if(!that.hasClass('close')) {
    //             wrapper.addClass('opened');
    //         } else {
    //             wrapper.removeClass('opened');
    //         }
    //     })
    // })
  }

  mobileMenuUser();

  /** End мобильного меню **/
  // if (WIN.width() <= 767) {
  //     $('.user-info__profile-name').addClass('user-info__profile-name--mobile');
  // }
  //
  // WIN.on('resize', function() {
  //     if (WIN.width() <= 767) {
  //         $('.user-info__profile-name').addClass('user-info__profile-name--mobile');
  //     }
  //     else $('.user-info__profile-name').removeClass('user-info__profile-name--mobile');
  // });

  /** Рейтинг игры на странице Demo game **/
  var rating = $("[data-rating]");
  var isLogged = rating.data("logged") ? true : false;

  rating.rating({
    fx: "half",
    image: "/front/img/elements/stars.png",
    loader: "/front/img/elements/ajax-loader.gif",
    readOnly: isLogged,
  });
  if (isLogged) {
    $(".vote-hover").css({
      cursor: "default",
    });
  }
  /** End Рейтинг игры на странице Demo game **/

  /** Cлайдер на главной странице */
  var homepageSlider = new Swiper("[data-slider-homepage]", {
    speed: 1000,
    slidesPerView: 3,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    centeredSlides: true,
    loop: true,
    preloadImages: true,
    lazy: true,
    breakpoints: {
      1440: {
        slidesPerView: "auto",
      },
    },
  });

  /** Cлайдер на странице c играми */
  var mainSlider = new Swiper("[data-slider-main]", {
    speed: 1000,
    slidesPerView: "auto",
    slidesPerGroup: 1,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    effect: "fade",
    initialSlide: 0,
    centeredSlides: true,
    loop: true,
    preloadImages: false,
    lazy: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  /** Cлайдер game menu */
  $("[data-slider-menu]").each(function () {
    // используемые классы
    let name = $(this);

    let menuSlider = new Swiper(name.find(".swiper-container"), {
      slidesPerView: "auto",
      freeMode: true,
      slideClass: "games__menu-item",
      scrollbar: {
        el: name.find(".swiper-scrollbar"),
        hide: false,
      },
    });
  });

  /** Cлайдер game-type menu */
  $("[data-slider-type-menu]").each(function () {
    // используемые классы
    let name = $(this);

    let menuSlider = new Swiper(name.find(".swiper-container"), {
      slidesPerView: "auto",
      freeMode: true,
      slideClass: "games-types__item",
      scrollbar: {
        el: name.find(".swiper-scrollbar"),
        hide: false,
      },
    });
  });

  /** Слайдер игр на главной **/

  $("[data-games-slider]").each(function () {
    // используемые классы
    let name = $(this);

    let gameSlider = new Swiper(name.find(".swiper-container"), {
      loop: false,
      centeredSlides: false,
      slideClass: "games__item",
      slidesPerView: 5,
      slidesPerGroup: 1,
      spaceBetween: 10,
      pagination: {
        el: name.find(" .swiper-pagination"),
        clickable: true,
      },
      breakpoints: {
        1220: {
          slidesPerView: "auto",
          loop: true,
          centeredSlides: true,
        },
      },
    });
  });

  /** Слайдер победителей на главной **/
  var winnersSlider = new Swiper("[data-slider-winners]", {
    // loop: true,
    speed: 1000,
    direction: "vertical",
    spaceBetween: 10,
    slidesPerView: 5,
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
  });
  /**  End Слайдер победителей на главной **/

  /** Слайдер новостей на главной **/
  var newsSlider = new Swiper("[data-news-slider] .swiper-container", {
    speed: 1000,
    loop: false,
    slidesPerView: 3,
    slidesPerGroup: 1,
    spaceBetween: 30,
    // autoplay: {
    //     delay: 5000,
    //     disableOnInteraction: false
    // },

    breakpoints: {
      520: {
        spaceBetween: 20,
        slidesPerView: 1,
        slidesPerGroup: 1,
      },
      768: {
        spaceBetween: 20,
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      1220: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
    },
  });
  /** End слайдер новостей на главной **/

  /** Слайдер турниров на главной **/
  var tournamentsSlider = new Swiper(
    "[data-tournaments-slider] .swiper-container",
    {
      speed: 1000,
      loop: false,
      slidesPerView: 5,
      slidesPerGroup: 1,
      spaceBetween: 30,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: "[data-tournaments-slider] .swiper-button-next",
        prevEl: "[data-tournaments-slider] .swiper-button-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: "auto",
          slidesPerGroup: 1,
          spaceBetween: 25,
        },
        980: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
        1280: {
          slidesPerView: 3,
          slidesPerGroup: 3,
        },
      },
    }
  );
  /** End слайдер турниров на главной **/

  /** Слайдер SEO TEXT на главной **/
  var seotextSlider = new Swiper("[data-seo-text]", {
    direction: "vertical",
    slidesPerView: "auto",
    freeMode: true,
    scrollbar: {
      el: ".swiper-scrollbar",
    },
    mousewheel: true,
  });
  /** End слайдер SEO TEXT на главной **/

  /** Слайдер турнирных игр на странице турниры и турнир **/

  $("[data-recent-games-slider]").each(function () {
    // используемые классы
    let name = $(this);
    let recentSlider = new Swiper(name.find(".swiper-container"), {
      speed: 1000,
      slideClass: "games-recent__item",
      slidesPerView: 5,
      slidesPerGroup: 1,
      spaceBetween: 25,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },

      breakpoints: {
        480: {
          slidesPerView: 1,
          slidesPerGroup: 1,
        },
        980: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
        1200: {
          slidesPerView: 3,
          slidesPerGroup: 3,
        },
        1440: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        },
      },
    });
  });

  /** Слайдер выбора бонуса на депозит в модалке **/
  function chooseBonus() {
    $("[data-choose-bonus-slider]").each(function () {
      let name = $(this);
      if (
        name.length > 0 &&
        name.is(":visible") &&
        name.find(".swiper-slide-active").length < 1
      ) {
        // используемые классы
        let chooseSlider = new Swiper(name.find(".swiper-container"), {
          slideClass: "bonuses__item",
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 25,
          pagination: {
            el: name.find(".swiper-pagination"),
            clickable: true,
          },
          navigation: {
            nextEl: name.find(" .slider-arrow--next"),
            prevEl: name.find(" .slider-arrow--prev"),
          },
        });
      }
    });
  }
  chooseBonus();

  /**
   * Обработчик кнопки добавления в избранное
   * */
  // DOC.on('click', '.games__item--favorite', function(){
  //     $(this).toggleClass('active');
  // });

  /**  Search input **/

  $(".search").click(function () {
    $(this).toggleClass("active");
    $(this).next(".search-bar").toggleClass("active");

    // $('.search-bar input').focus();
  });
  DOC.on("click", function (e) {
    var searchbar = $(".search-bar");
    if (searchbar.hasClass("active")) {
      if (!$(e.target).closest(".search__wrapper").length) {
        searchbar.removeClass("active");
        $(".search.active").removeClass("active");
      }
      e.stopPropagation();
    }
  });

  // WIN.on('resize', function() {
  //     $('.search-bar.active').each(function() {
  //         $('.search-bar.active').removeClass('active');
  //     });
  // });

  $(".search-bar .close-button").click(function () {
    $(".search-bar.active").removeClass("active");
    $(".search.active").removeClass("active");
  });

  /**  End search input **/

  /**  Анимация табов **/

  var tabs = $(".tabs");
  var selector = $(".tabs").find("li").length;
  //var selector = $(".tabs").find(".selector");
  var activeItem = tabs.find(".active");
  var activeWidth = activeItem.innerWidth();
  $(".selector").css({
    left: activeItem.position.left + "px",
    width: activeWidth + "px",
  });
  /**  End Анимация табов **/

  /** Tabs + cookie / profile: bonuses player page -------------- **/
  function bonusesSwitcher(e) {
    const bonusesActive = $("[data-bonuses-active]");
    const bonusesActiveContent = $("[data-bonuses-active-content]");

    const bonusesAvailable = $("[data-bonuses-available]");
    const bonusesAvailableContent = $("[data-bonuses-available-content]");

    bonusesAvailable.on("click", function () {
      bonusesActive.removeClass("active");
      bonusesActiveContent.removeClass("active");
      bonusesAvailable.addClass("active");
      bonusesAvailableContent.addClass("active");
      $.cookie("BonusesSwitcher", "bonuses-available", {
        path: "/",
      });
      lazyLoad();
    });

    bonusesActive.on("click", function () {
      bonusesAvailable.removeClass("active");
      bonusesAvailableContent.removeClass("active");
      bonusesActive.addClass("active");
      bonusesActiveContent.addClass("active");
      $.cookie("BonusesSwitcher", "bonuses-active", {
        path: "/",
      });
      lazyLoad();
    });
  }

  bonusesSwitcher();
  /** End Tabs profile bonuses **/

  /** ADD cookies profile bonuses switcher **/
  function setBonusesView() {
    if ($.cookie("BonusesSwitcher") == null) {
      $.cookie("BonusesSwitcher", "bonuses-available", {
        path: "/",
      });
    }

    setTimeout(function () {
      if ($.cookie("BonusesSwitcher") == "bonuses-available") {
        $("[data-bonuses-available]").click();
      }
    }, 100);

    setTimeout(function () {
      if ($.cookie("BonusesSwitcher") == "bonuses-active") {
        $("[data-bonuses-active]").click();
      }
    }, 100);
  }

  setBonusesView();
  /** END ADD cookies profile bonuses switcher **/

  /**
   * Стилизация скроллабара в блоках
   */
  $("[data-scrollbar]").scrollbar({
    showArrows: true,
    scrolly: "advanced",
    ignoreOverlay: true,
  });

  $(".scroll-wrapper").each(function () {
    setTimeout(function () {
      if ($(this).height() < $(this).parent().height()) {
        $(this).addClass("scroll--void").find(".scroll-element").hide();
      }
    }, 100);
  });

  // Поля ввода верификационного кода на странице 2fac
  function enterCode() {
    let $formCode = $("#two-factor-verify-form");
    let $inputList = $formCode.find(".twofac__content--pincode");
    let $inputCode = $formCode.find('input[type="number"]');
    $inputCode.keydown(function (e) {
      // $(this).val('');
      if (
        e.key === "Enter" ||
        e.key === "ArrowLeft" ||
        e.key === "ArrowRight"
      ) {
        return $(this).val();
      } else $(this).val("");
    });

    $inputCode.keyup(function (e) {
      let val = $(this).val();

      // Ввод только цифр
      if (/^\d+$/.test(val) === false) {
        $(this).val("");
        $formCode.find("input.hidden-code").change();
        return false;
      }

      // Передача фокуса следующему input
      $inputCode.eq($inputCode.index(this) + 1).focus();

      // Заполнение input hidden
      let fullval = "";
      $inputCode.each(function () {
        fullval = fullval + $(this).val();
      });
      $formCode.find("input.hidden-code").val(fullval);
      $formCode.find("input.hidden-code").change();
    });

    $inputCode.keyup(function (e) {
      if (e.key === "Backspace") {
        if ($inputCode.index(this) === 0) {
          $(this).val("");
        } else {
          $inputCode.eq($inputCode.index(this) - 1).focus();
          $(this).val("");
        }
      } else if (e.key === "ArrowLeft") {
        $inputCode.eq($inputCode.index(this) - 1).focus();
      } else if (e.key === "ArrowRight") {
        $inputCode.eq($inputCode.index(this) + 1).focus();
      }
    });

    $inputList.on("input", "input[name^=chars]", function (e) {
      var number = $(this).val();
      if (number.length > 1) {
        for (i = 1; i <= number.length; i++) {
          $("input[name^=chars]")
            .eq(i - 1)
            .val(number[i - 1])
            .trigger("change paste");
        }
      }
    });
  }
  enterCode();

  /**
   * Этот код подменяет ссылку на ссылках "Назад".
   * Смысл этих сложностей в том, чтобы поставить на ссылку "Назад" изначально повесить ссылку
   * на главную, которая сработает если посетитель пришел по прямой ссылке, а потом уже вешать
   * действительно предыдущую страницу, когда посетитель походил по страницам.
   * */
  if (window.sessionStorage.currPage) {
    if (
      !window.sessionStorage.prevPage ||
      window.sessionStorage.currPage !== window.location.toString()
    ) {
      window.sessionStorage.prevPage = window.sessionStorage.currPage;
    }
  } else {
    window.sessionStorage.prevPage = "/gameList";
  }
  if (window.sessionStorage.prevPage) {
    $("[data-go-back]").attr("href", window.sessionStorage.prevPage);
  }
  window.sessionStorage.currPage = window.location.toString();

  /** telegram message turning off **/
  DOC.on("click", "[data-telegram-close]", function () {
    $(".telegram-block__wrapper").removeClass("shown");
    if ($(".telegram-block__right .checkbox input").is(":checked")) {
      localStorage.setItem("telegram", "check");
      $(".telegram-block__wrapper").removeClass("shown");
    }
  });
  if (localStorage.telegram !== "check") {
    $(".telegram-block__wrapper").addClass("shown");
  }
  /** END telegram message turning off **/

  /**
   * Кнопка Копии в буфер обмена на странице 2fac
   **/
  DOC.on("click", "[data-click-copy]", function () {
    var temp = $("<input>");
    $("body").append(temp);
    temp.val($(".copy").text()).select();
    document.execCommand("copy");
    temp.remove();
  });

  /**  accordion / game page **/
  DOC.on("click", ".accordion__item--header", function () {
    var item = $(this).parents(".accordion__item");
    //item.siblings().removeClass('accordion__item--open');
    item.toggleClass("accordion__item--open");
  });
  /** end accordion / game page **/

  /** Описание игры **/
  // $('.show-more').click(function() {
  // 	$('.game-info__description').toggleClass("open");
  // 	//$(this).toggleClass("rotate");
  // });
  /** End Описание игры **/

  /** jackpots counter for numbers **/
  $("[data-jackpots-counter]").countUp();
  /** end jackpots counter for numbers **/

  /** обрезка текстовых привью (количество символов береться из дата атрибута) **/
  var shortText = $("[data-cut-text]");
  shortText.each(function () {
    var size = $(this).data("cutText"),
      elementText = $(this).text();
    if (elementText.length > size) {
      $(this).text(elementText.slice(0, size) + " ...");
    }
  });

  // var newsTitle = $('.news__title h3, .slider-news__title h3');
  // var bonusTitle = $('.bonuses__item__content .bonuses__name');
  // var userName = $('.user-info__profile-name');
  //
  // var newsContent = $('.slider-news__description, .news__description');
  // newsTitle.each(function() {
  //     var size = 26,
  //         newsText = $(this).text();
  //
  //     if (newsText.length > size) {
  //         $(this).text(newsText.slice(0, size) + ' ...');
  //     }
  // });
  // userName.each(function() {
  //     var size = 20,
  //         newsText = $(this).text();
  //
  //     if (newsText.length > size) {
  //         $(this).text(newsText.slice(0, size) + ' ...');
  //     }
  // });
  // bonusTitle.each(function() {
  //     var size = 30,
  //         newsText = $(this).text();
  //
  //     if (newsText.length > size) {
  //         $(this).text(newsText.slice(0, size) + ' ...');
  //     }
  // });
  // newsContent.each(function() {
  //     var size = 200,
  //         newsText = $(this).text();
  //
  //     if (newsText.length > size) {
  //         $(this).text(newsText.slice(0, size) + ' ...');
  //     }
  // });
  /** End обрезка превью новости **/

  /** Описание бонуса с flip-эффекто **/
  $("[data-bonus-fliper]").click(function () {
    var bonus = $(this).parents("[data-bonus-flip]");
    bonus.toggleClass("flip");
  });
  /** End **/

  /** Mobile tables **/
  (function () {
    var headertext = [];
    var headers = document.querySelectorAll("thead");
    var tablebody = document.querySelectorAll("tbody");

    for (var i = 0; i < headers.length; i++) {
      headertext[i] = [];
      for (var j = 0, headrow; (headrow = headers[i].rows[0].cells[j]); j++) {
        var current = headrow;
        headertext[i].push(current.textContent.replace(/\r?\n|\r/, ""));
      }
    }
    if (headers.length > 0) {
      for (var h = 0, tbody; (tbody = tablebody[h]); h++) {
        for (var i = 0, row; (row = tbody.rows[i]); i++) {
          for (var j = 0, col; (col = row.cells[j]); j++) {
            col.setAttribute("data-label", headertext[h][j]);
          }
        }
      }
    }
  })();
  /** End Mobile tables **/

  /** List to Grid view for tables **/
  function viewSwitcher(e) {
    const listButton = $("[data-view-table]");
    const gridButton = $("[data-view-grid]");
    const wrapper = $(".table");
    listButton.on("click", function () {
      gridButton.removeClass("active");
      listButton.addClass("active");
      wrapper.removeClass("table-grid").addClass("table-list");
      $.cookie("TableView", "table-view", {
        path: "/",
      });
    });
    gridButton.addClass("active");
    gridButton.on("click", function () {
      listButton.removeClass("active");
      gridButton.addClass("active");
      wrapper.removeClass("table-list").addClass("table-grid");
      $.cookie("TableView", "grid-view", {
        path: "/",
      });
    });
    setTimeout(function () {
      if (WIN.width() <= 768) {
        wrapper.removeClass("table-list").addClass("table-grid");
      }
    }, 200);
    WIN.on("resize", function () {
      if (WIN.width() <= 768) {
        wrapper.removeClass("table-list").addClass("table-grid");
      }
      if (WIN.width() > 768 && $("[data-view-table]").hasClass("active")) {
        wrapper.removeClass("table-grid").addClass("table-list");
      }
    });
  }
  // viewSwitcher();

  /** End List to Grid view for tables **/

  /** profile-menu toggler for open/close **/
  DOC.on("click", "[data-profile-menu]:not(.opened) i", function (event) {
    event.preventDefault();
    $("[data-profile-menu]").addClass("opened");
    $("[data-profile-menu-closer] i")
      .removeClass("icon-menu-open")
      .addClass("icon-menu-close");
  });
  DOC.on(
    "click",
    "[data-profile-menu].opened [data-profile-menu-closer]",
    function () {
      $("[data-profile-menu]").removeClass("opened");
      $("[data-profile-menu-closer] i")
        .removeClass("icon-menu-close")
        .addClass("icon-menu-open");
    }
  );
  /** end profile-menu toggler for open/close **/

  /** ADD cookies List to Grid view for tables **/
  function setTableView() {
    if ($.cookie("TableView") == null) {
      $.cookie("TableView", "grid-view", {
        path: "/",
      });
    }
    if ($.cookie("TableView") == "grid-view") {
      $("[data-view-grid]").click();
    }
    if ($.cookie("TableView") == "table-view") {
      $("[data-view-table]").click();
    }
  }
  setTableView();
  /** END ADD cookies List to Grid view for tables **/

  /** Реализация адаптивности iframe в статьях **/
  $(".article__content iframe").each(function () {
    $(this).wrap('<div class="videowrapper">');
  });
  /** end **/

  /** Инициализация типовых модалок **/
  $("[data-modal]").magnificPopup({
    type: "ajax",
    removalDelay: 300,
    mainClass: "mfp-zoom-in",
    callbacks: {
      parseAjax: function (mfpResponse) {
        mfpResponse.data =
          "<div class='wrapping'>" + mfpResponse.data + "</div>";
      },
      ajaxContentAdded: function () {
        this.content;
      },
      open: function () {
        $(".header").css("width", "calc(100% - " + scrollWidth + "px)");
      },
      close: function () {
        $(".header").css("width", "100%");
      },
      beforeOpen: function () {
        $("body").addClass("blur");
      },
      beforeClose: function () {
        $("body").removeClass("blur");
      },
    },
  });
  /** End Инициализация модалок **/

  /** Инициализация модального окна, которое невозможно закрыть */
  $("[data-modal--immortal]").magnificPopup({
    type: "ajax",
    removalDelay: 300,
    mainClass: "mfp-zoom-in",
    closeOnBgClick: false,
    showCloseBtn: false,
    enableEscapeKey: false,
    callbacks: {
      parseAjax: function (mfpResponse) {
        mfpResponse.data =
          "<div class='wrapping'>" + mfpResponse.data + "</div>";
      },
      ajaxContentAdded: function () {
        this.content;
      },
      open: function () {
        $(".header").css("width", "calc(100% - " + scrollWidth + "px)");
      },
      close: function () {
        $(".header").css("width", "100%");
      },
      beforeOpen: function () {
        $("body").addClass("blur");
      },
      beforeClose: function () {
        $("body").removeClass("blur");
      },
    },
  });
  /** End **/

  /**
   * Появление и скрытие поля с ответом на секретный вопрос
   * Появление\скрытие инпута в инициализации selectric'a
   **/
  let secret_question = $(".secret_question"),
    secret_answer = $(".secret_answer");
  if (!secret_question.val()) {
    secret_answer.hide();
  }
  /** End **/

  /**
   * Инициализация select menu
   * Используется в формах, которые подгружаются на ajax
   * Для этого вынесен в функцию для использования внутри ajaxSuccess
   **/
  function selectInit() {
    $("[data-select-menu]").each(function () {
      if (!$(this).parent().hasClass("selectric-hide-select")) {
        $(this).selectric({
          maxHeight: 200,
          disableOnMobile: false,
          nativeOnMobile: false,
          onInit: function () {
            var current_option = $(this),
              current_option_value = current_option.val(),
              selectric_container = $(this)
                .parents(".selectric-wrapper")
                .find(".selectric");

            // проверка для вывода поля с секретным ответом
            if (current_option.hasClass("secret_question")) {
              if (current_option_value) {
                secret_answer.show();
              } else {
                secret_answer.hide();
              }
            }

            //  эмуляция placeholder'a для селектрика
            if (current_option_value) {
              selectric_container.removeClass("selectric--placeholder");
            } else {
              selectric_container.addClass("selectric--placeholder");
            }

            // проверка на количество эллементов, если 1 - то добавляем класс,
            // который скрывает всю навигацию
            if (current_option.find("option").length === 1) {
              current_option
                .parents(".selectric-wrapper")
                .addClass("selectric--void");
            }
          },
          onChange: function (element) {
            var current_option = $(this),
              current_option_value = current_option.val(),
              selectric_container = $(this)
                .parents(".selectric-wrapper")
                .find(".selectric");

            // проверка для вывода поля с секретным ответом
            if (current_option.hasClass("secret_question")) {
              if (current_option_value) {
                secret_answer.show();
              } else {
                secret_answer.hide();
              }
            }

            //  эмуляция placeholder'a для селектрика
            if (current_option_value) {
              selectric_container.removeClass("selectric--placeholder");
            } else {
              selectric_container.addClass("selectric--placeholder");
            }
          },

          labelBuilder: function (currItem) {
            // return currItem.text + ' <span>*</span>';
            return currItem.text;
          },
        });
      }
    });
  }
  selectInit();
  /** End **/

  /** Инициализация плагина обратного отсчета для бонусов в шапке */
  // $('[data-time-bonus-header]').each(function() {
  //     $(this).countdown($(this).attr('data-time-bonus-header'), function(event) {
  //         $(this).html(event.strftime('' +
  //             '<div class="counter__block">%D ' +
  //             $(this).attr('data-days') +
  //             '</div>' +
  //             '<div class="counter__block">%H ' +
  //             $(this).attr('data-hours') +
  //             '</div>' +
  //             '<div class="counter__block">%M ' +
  //             $(this).attr('data-min') +
  //             '</div>' +
  //             '<div class="counter__block">%S ' +
  //             $(this).attr('data-sec') +
  //             '</div>'
  //         ));
  //     });
  // });
  /** End **/

  /** Меню провайдеров в селектменю **/

  DOC.on("click", function (e) {
    var container = $("[data-provider-menu]");
    var btncontainer = $("[data-provider-menu-opener]");
    if (container.hasClass("opened")) {
      if (!$(e.target).closest("[data-provider-menu-opener]").length) {
        container.removeClass("opened");
        btncontainer.removeClass("active");
      }
      e.stopPropagation();
    }

    // var btnselect = $('.games__sort--menu .selectric-wrapper');
    //
    // if (btnselect.hasClass('selectric-open')) {
    //     if (btnselect.hasClass('selectric-open') && !btnselect.is(e.target) && btnselect.has(e.target).length === 0) {
    //         btnselect.removeClass('selectric-open');
    //     }
    //     e.stopPropagation();
    // }
  });

  $("[data-provider-menu-opener]").click(function () {
    $(this).toggleClass("active");
    $("[data-provider-menu]").toggleClass("opened");

    // if ($('.games__sort--menu .selectric-wrapper').hasClass('selectric-open')) {
    //     $('.games__sort--menu .selectric-wrapper').removeClass('selectric-open');
    // }
  });

  /** End **/

  /** Block Seo-text **/

  $(".seo-text__show-more").on("click", function () {
    $(this).toggleClass("rotate");
    $(".seo-text__wrapper").toggleClass("open");
  });

  /** End Block Seo-text **/

  /** Инициализация select menu валют **/
  $("[data-select-currency]")
    .selectric({
      disableOnMobile: false,
      nativeOnMobile: false,
      onInit: function () {
        if ($(this).find("option").length === 1) {
          $(this).parents(".selectric-wrapper").addClass("selectric--void");
        }
      },
    })
    .on("change", function () {
      location.href = $(this).val();
    });
  /** End Инициализация select menu валют **/

  /** Fix для пагинации таблиц в кабинете игрока (решение под вопросом, костыль из-за бэкендеров) **/
  DOC.on("click", ".pager__item a", function (event) {
    $("html, body").animate(
      {
        scrollTop: $("#table-top").offset().top,
      },
      500
    );
  });
  /** End Fix для пагинации таблиц в кабинете игрока **/

  /** Fix Hover on mobile **/
  fixHover(
    ".games__item",
    ".games__item__overlay",
    "games__item__overlay--active"
  );

  function fixHover(sSelestor, sHover, sActiveClass) {
    $(sSelestor).hover(
      function () {
        $(this).find(sHover).addClass(sActiveClass);
      },
      function () {
        $(this).find(sHover).removeClass(sActiveClass);
      }
    );
  }
  /** End Fix Hover on mobile **/

  /**
   * Инициализация поля выбора даты
   * Используется в формах, которые подгружаются на ajax
   * Для этого вынесен в функцию для использования внутри ajaxSuccess
   **/
  function dateInit() {
    var langdef = $("html").attr("lang");

    let input_date = $("[data-datepicker]");
    if (input_date.length > 0 && input_date.is(":visible")) {
      if (!$(".datepickers-container").length) {
        let date = new Date().getFullYear();
        let maxdate = new Date();
        maxdate.setYear(date - 18);

        input_date.datepicker({
          maxDate: maxdate,
          autoClose: true,
          dateFormat: "yyyy-mm-dd",
          language: langdef,
        });
      }
    }
  }

  dateInit();
  /** End **/

  /** Вызов transaction filters (menu) в модалке **/
  $("[data-transaction-filters]").magnificPopup({
    type: "inline",
    preloader: true,
    removalDelay: 500,
    mainClass: "transaction-filters",
  });

  /** Avatar load в профиле Игрока **/
  var readURL = function (input) {
    if (input.files && input.files[0]) {
      var reader = new FileReader();
      reader.onload = function (e) {
        $(".profile-pic").attr("src", e.target.result);
      };
      reader.readAsDataURL(input.files[0]);
    }
  };
  $("#avatar-form").submit(function () {
    readURL($("#avatar-input"));
  });

  $("[data-avatar-submit]").on("click", function () {
    $("[data-avatar-upload]").click();
  });

  /** End Avatar load в профиле Игрока **/

  /** Document load в кабинете Игрока **/
  $(".upload-button").on("click", function () {
    $(".file-upload").click();
  });
  /** End Document load в кабинете Игрока **/

  /** Tabs для форм на странице профиля игрока **/

  // $(".tabs").on("click","li",function(e){
  //     e.preventDefault();
  //     $('.tabs li').removeClass("active").siblings().removeClass('active').closest('section.page-profile__content').find('div.tabs__content').removeClass('active').eq($(this).index()).addClass('active');
  //     $(this).addClass('active');
  //     var activeWidth = $(this).innerWidth();
  //     var itemPos = $(this).position();
  //     $(".selector").css({
  //         "left":itemPos.left + "px",
  //         "width": activeWidth + "px"
  //     });
  // });

  function profileSwitcher(e) {
    const profilePersonal = $("[data-profile-personal]");
    const profilePersonalContent = $("[data-profile-personal-content]");

    const profileLocation = $("[data-profile-location]");
    const profileLocationContent = $("[data-profile-location-content]");

    const profileContacts = $("[data-profile-contacts]");
    const profileContactsContent = $("[data-profile-contacts-content]");

    const profileSecurity = $("[data-profile-security]");
    const profileSecurityContent = $("[data-profile-security-content]");

    profilePersonal.on("click", function () {
      profileLocation.removeClass("active");
      profileLocationContent.removeClass("active");
      profileContacts.removeClass("active");
      profileContactsContent.removeClass("active");
      profileSecurity.removeClass("active");
      profileSecurityContent.removeClass("active");
      profilePersonal.addClass("active");
      profilePersonalContent.addClass("active");
      $.cookie("ProfileSwitcher", "profile-personal", {
        path: "/",
      });
      lazyLoad();
    });

    profileLocation.on("click", function () {
      profileLocation.addClass("active");
      profileLocationContent.addClass("active");
      profileContacts.removeClass("active");
      profileContactsContent.removeClass("active");
      profileSecurity.removeClass("active");
      profileSecurityContent.removeClass("active");
      profilePersonal.removeClass("active");
      profilePersonalContent.removeClass("active");
      $.cookie("ProfileSwitcher", "profile-location", {
        path: "/",
      });
      lazyLoad();
    });

    profileContacts.on("click", function () {
      profileLocation.removeClass("active");
      profileLocationContent.removeClass("active");
      profileContacts.addClass("active");
      profileContactsContent.addClass("active");
      profileSecurity.removeClass("active");
      profileSecurityContent.removeClass("active");
      profilePersonal.removeClass("active");
      profilePersonalContent.removeClass("active");
      $.cookie("ProfileSwitcher", "profile-contacts", {
        path: "/",
      });
      lazyLoad();
    });

    profileSecurity.on("click", function () {
      profileLocation.removeClass("active");
      profileLocationContent.removeClass("active");
      profileContacts.removeClass("active");
      profileContactsContent.removeClass("active");
      profileSecurity.addClass("active");
      profileSecurityContent.addClass("active");
      profilePersonal.removeClass("active");
      profilePersonalContent.removeClass("active");
      $.cookie("ProfileSwitcher", "profile-security", {
        path: "/",
      });
      lazyLoad();
    });
  }

  profileSwitcher();

  // ADD cookies profile tabs switcher
  function setProfileView() {
    if ($.cookie("ProfileSwitcher") == null) {
      $.cookie("ProfileSwitcher", "profile-personal", { path: "/" });
    }

    if ($.cookie("ProfileSwitcher") == "profile-personal") {
      $("[data-profile-personal]").click();
    }
    if ($.cookie("ProfileSwitcher") == "profile-location") {
      $("[data-profile-location]").click();
    }
    if ($.cookie("ProfileSwitcher") == "profile-contacts") {
      $("[data-profile-contacts]").click();
    }
    if ($.cookie("ProfileSwitcher") == "profile-security") {
      $("[data-profile-security]").click();
    }
  }
  setProfileView();

  /** End Tabs на странице профиля **/

  /** !!! определить необходимость для данного проекта !!! **/
  DOC.on("click", "[data-sidebar-toggler]", function () {
    var sidebar = $("[data-sidebar]");
    $(this).toggleClass("active");
    sidebar.slideToggle();
    sidebar.toggleClass("open");
  });
  /** !!! определить необходимость для данного проекта !!! **/

  /** Определяем ширину скроллбара в текущем браузере !!! определить необходимость для данного проекта !!!????? **/
  var div = document.createElement("div");

  div.style.overflowY = "scroll";
  div.style.width = "50px";
  div.style.height = "50px";
  div.style.visibility = "hidden";

  document.body.appendChild(div);
  var scrollWidth = div.offsetWidth - div.clientWidth;
  document.body.removeChild(div);
  /** End Определяем ширину скроллбара в текущем браузере **/

  /** Событие клика на элементе faq. Показывает\скрывает ответ на вопрос */
  DOC.on("click", "[data-faq-question]", function () {
    var item = $(this).parents(".faq__item");
    item.find(".faq__answer").slideToggle();
    item.toggleClass("faq--open");
  });
  /** End **/

  /** Иниализация отложенной подгрузки изображений + замена битого изображения логотипом проекта */
  function lazyLoad() {
    $("[data-lazy] img[data-src]").Lazy({
      scrollDirection: "vertical",
      effect: "fadeIn",
      effectTime: 1000,
      // threshold: 0,
      // visibleOnly: false,
      onError: function (element) {
        element
          .attr("src", "/front/img/logos/no-photo.png")
          .addClass("no-photo");
      },
    });
  }
  lazyLoad();
  /** End **/

  /** Событие смены видимости пароля в инпуте */
  var passwordToggler = "[data-password-toggler]";
  DOC.on("click", passwordToggler, function () {
    var btn = $(this),
      input = btn.siblings("input");
    btn.toggleClass("icon-view");
    btn.toggleClass("icon-hide");
    if (input.attr("type") == "text") {
      input.attr("type", "password");
    } else {
      input.attr("type", "text");
    }
  });
  /** End **/

  /** Инициализация плагина обратного отсчета */
  $("[data-time]").each(function () {
    $(this).countdown($(this).attr("data-time"), function (event) {
      $(this).html(
        event.strftime(
          "" +
            '<div class="counter__block">' +
            '<span class="counter__value">%D</span>' +
            '<span class="counter__desc">' +
            $(this).attr("data-days") +
            "</span>" +
            "</div>" +
            "<dl>:</dl>" +
            '<div class="counter__block">' +
            '<span class="counter__value">%H</span>' +
            '<span class="counter__desc">' +
            $(this).attr("data-hours") +
            "</span>" +
            "</div>" +
            "<dl>:</dl>" +
            '<div class="counter__block">' +
            '<span class="counter__value">%M</span>' +
            '<span class="counter__desc">' +
            $(this).attr("data-min") +
            "</span>" +
            "</div>" +
            "<dl>:</dl>" +
            '<div class="counter__block">' +
            '<span class="counter__value">%S</span>' +
            '<span class="counter__desc">' +
            $(this).attr("data-sec") +
            "</span>" +
            "</div>"
        )
      );
    });
  });
  /** End **/

  /** Tabs для формы регистрации **/
  $("ul.registration__tabs--top").on("click", "li:not(.active)", function () {
    $(this)
      .addClass("active")
      .siblings()
      .removeClass("active")
      .closest("div.registration__tabs")
      .find("div.registration__tabs--content")
      .removeClass("active")
      .eq($(this).index())
      .addClass("active");
    // if ($('[data-phone-tab]').hasClass('active')) {
    //     phoneInit();
    // }
  });
  /** End **/

  /** Маска для телефонного инпута **/

  // $(function($){
  //     $("input[type='tel']").mask("+(99) 99999-99999", {autoclear: false});
  // });

  /** End **/

  /** Проверка на наличие блока с бонусным таймером в шапке, если есть - добавляем отступ хелперу **/
  // if ($(".header__bonus").length) {
  //     DOC.find('.helper.logged').css("margin-top","253px");
  // }
  /** End **/

  /** Фиксирование таймера к верху на залогиненной главной странице **/
  $(window).scroll(function () {
    var the_top = $(document).scrollTop();
    if (the_top > 170) {
      $(".header__bonus").addClass("fixed");
    } else {
      $(".header__bonus").removeClass("fixed");
    }
  });
  /** End **/

  /** Инициализация тел. номера **/
  var input = document.querySelector("[data-phone-number]");

  if ($("[data-phone-number]").length) {
    window.intlTelInput(input, {
      initialCountry: "auto",
      autoHideDialCode: true,
      nationalMode: false,
      hiddenInput: "full_phone",
      numberType: "MOBILE",
      geoIpLookup: function (callback) {
        $.get("https://ipinfo.io", function () {}, "jsonp").always(function (
          resp
        ) {
          var countryCode = resp && resp.country ? resp.country : "";
          callback(countryCode);
        });
      },
      utilsScript: "/front/js/utils.js",
    });
  }
  /** End **/

  /** Tabs с дополнительной инофрмацией на странице отдельной игры **/
  $("[data-game-tabs]").on("click", "li:not(.active)", function () {
    $(this)
      .addClass("active")
      .siblings()
      .removeClass("active")
      .closest("div.game__box--right")
      .find("div.tabs__content")
      .removeClass("active")
      .eq($(this).index())
      .addClass("active");
    if ($("[data-tabs-tournament]").hasClass("active")) {
      $("[data-topinfo]").addClass("open");
    } else {
      $("[data-topinfo]").removeClass("open");
    }
  });
  /** End **/

  /**
   * Условие проверки входа через IE
   * И вывод соответствующего сообщения об устаревшем браузере
   **/
  if (!HTML.hasClass("ie")) {
    $(".ieOff").remove();
  }
  /** End **/

  /**
   * Детектирование включенного AdBlock'a у пользователя
   * Если он активирован - выводим сообщение
   * При закрытии этого сообщение результат записываем в sessionStorage
   * и в следующий раз уже не отображаем сообщение
   **/
  //sessionStorage.clear();  // очищаем sessionStorage и показываем уведомление при каждой перезагрузке

  let alert_container = $(".alert");
  function adBlockDetected() {
    let alert_status = sessionStorage.getItem("alert");
    if (alert_status !== "0") {
      alert_container.show();
    }
  }
  if (typeof fuckAdBlock === "undefined") {
    adBlockDetected();
  } else {
    fuckAdBlock.onDetected(adBlockDetected);
  }
  DOC.on("click", "[data-alert-close]", function () {
    alert_container.hide();
    sessionStorage.setItem("alert", "0");
  });

  /** Language select **/
  DOC.on("click", ".lang-select", function () {
    $(this).toggleClass("open");
  });
  $(".lang-select .lang-select__item").click(function () {
    $(this).siblings(".lang-select__item").removeClass("active");
    $(this).toggleClass("active");
  });

  /** Закрытие списка языков при клике вне его **/
  DOC.on("click", function (e) {
    if (!$(e.target).closest(".lang").length) {
      $(".lang-select").removeClass("open");
    }
    e.stopPropagation();
  });
  /** End **/

  /** Tabs + cookies / Profile transaction history **/
  function historySwitcher(e) {
    const historyDeposit = $("[data-history-deposit]");
    const historyDepositContent = $("[data-history-deposit-content]");
    const historywithdraw = $("[data-history-withdraw]");
    const historywithdrawContent = $("[data-history-withdraw-content]");
    historywithdraw.on("click", function () {
      historyDeposit.removeClass("active");
      historyDepositContent.removeClass("active");
      historywithdraw.addClass("active");
      historywithdrawContent.addClass("active");
      $.cookie("HistorySwitcher", "history-withdraw", { path: "/" });
    });
    historyDeposit.on("click", function () {
      historywithdraw.removeClass("active");
      historywithdrawContent.removeClass("active");
      historyDeposit.addClass("active");
      historyDepositContent.addClass("active");
      $.cookie("HistorySwitcher", "history-deposit", { path: "/" });
    });
  }
  historySwitcher();
  //-- End Tabs история транзакций

  // ADD cookies history transaction switcher
  function setHistoryView() {
    if ($.cookie("HistorySwitcher") == null) {
      $.cookie("HistorySwitcher", "history-withdraw", { path: "/" });
    }
    if ($.cookie("HistorySwitcher") == "history-withdraw") {
      $("[data-history-withdraw]").click();
    }

    if ($.cookie("HistorySwitcher") == "history-deposit") {
      $("[data-history-deposit]").click();
    }
  }
  setHistoryView();
  /** END tabs + cookies / Profile transaction history **/

  /**
   * Инициализация модального окна, inline type
   */

  $("[data-modal-inline]").magnificPopup({
    type: "inline",
    midClick: true,
  });

  /** Событие срабатывает в случае успешного выполнения ajax запроса **/
  $(document).on("ajaxSuccess", function () {
    selectInit();
    lazyLoad();
    enterCode();
    dateInit();
    /** Слайдер выбора бонуса на депозит в модалке **/
    chooseBonus();
    inputAnimation();
  });

  /** Раскрытие фрейма с игрой на весь экран **/
  $("[data-fullscreen-game]").click(function () {
    $(".game__iframe iframe, .game__iframe img").fullscreen();
  });

  /**
   * Раскрытие фрейма с игрой на доступную ширину в контентной части сайта
   * **/
  DOC.on("click", "[data-game-widescreen]", function () {
    $(this)
      .toggleClass("active")
      .parents(".game")
      .toggleClass("hide-game-panel");
  });

  /** main menu hide to more **/

  function responseMenu() {
    $("ul.games-types__dropdown-menu li.games-types__item").appendTo(
      "ul.games-types"
    );
    var items = $("ul.games-types li.games-types__item");
    var max_width =
      $("ul.games-types").width() -
      $("ul.games-types li.games-types__dd-menu").outerWidth();
    var width = 0;
    var hide_from = 0;

    items.css({ width: "auto" });

    items.each(function (index) {
      if (width + $(this).outerWidth() > max_width) {
        return false;
      } else {
        hide_from = index;
        width += $(this).outerWidth();
      }
    });
    if (hide_from < items.length - 1) {
      items
        .eq(hide_from)
        .nextAll("li.games-types__item")
        .appendTo("ul.games-types__dropdown-menu");
      // items.css({'width':(max_width / (hide_from + 1)) + 'px'});
      $("ul.games-types li.games-types__dd-menu").addClass("hidden-menu");
    } else {
      $("ul.games-types li.games-types__dd-menu").removeClass("hidden-menu");
    }
  }

  $(document).ready(function () {
    $(".games-types__wrapper").on(
      "click",
      ".games-types__dd-menu.hidden-menu",
      function () {
        $("ul.games-types li.games-types__dd-menu").toggleClass("open");
      }
    );

    $(window)
      .on("resize", function () {
        responseMenu();
      })
      .trigger("resize");
  });

  /** END main menu hide to more **/

  /** games slots menu **/

  DOC.on("click", function (e) {
    var container = $("[data-games-slots]");
    var btncontainer = $(".games-types__slots--btn");
    if (container.hasClass("opened")) {
      if (!$(e.target).closest(".games-types__slots--btn").length) {
        container.removeClass("opened");
        btncontainer.removeClass("active");
      }
      e.stopPropagation();
    }

    var btnmore = $("ul.games-types li.games-types__dd-menu");

    if (btnmore.hasClass("open")) {
      if (
        btnmore.hasClass("open") &&
        !btnmore.is(e.target) &&
        btnmore.has(e.target).length === 0
      ) {
        btnmore.removeClass("open");
      }
      e.stopPropagation();
    }
  });

  $("[data-games-slots-btn]").click(function () {
    $(this).parent().toggleClass("active");
    $("[data-games-slots]").toggleClass("opened");

    if ($("ul.games-types li.games-types__dd-menu").hasClass("open")) {
      $("ul.games-types li.games-types__dd-menu").removeClass("open");
    }
  });

  /** END games slots menu **/

  /** mobile submenu **/

  $("[data-mobile-submenu]").click(function () {
    $(this).parent().toggleClass("opened");
  });

  /** END mobile submenu **/

  function LangMove() {
    if (WIN.width() < 768) {
      $(".header--right .lang").appendTo(".header--left");
    } else {
      $(".header--left .lang").appendTo(".header--right");
    }
  }

  WIN.on("resize", function () {
    LangMove();
  });

  LangMove();

  /** footer menu **/

  $(".footer__menu--title").click(function () {
    if (WIN.width() <= 580) {
      $(this).parent().toggleClass("active");
    }
  });

  /**
   *  Табы в виде трансформера из табов в селекты
   *
   *    data-tabs - аттрибут, по которому происходит инициализация работы табов
   *
   *    data-tabs-save - аттрибут, который, фактически активирует сохранение активного таба в LocalStorage
   *        Для него нужно указать имя, которое будет использоваться для идентификации текущей страницы
   *
   *    data-tabs-sync - аттрибут, который активирует синхронизацию двух табов
   *        Его нужно задать для того селекта, С КОТОРЫМ нужно синхронизировать активный
   *        Если задать для обоих селектов - синхронизация будет работать в обе стороны
   *
   *    data-tabs-transform - аттрибут, значение в котороым указывает ширину экрана, меньше которой табы будут трансформироваться в селект
   *
   *    data-tabs-selector - аттрибут, добавляем его в случае, если нужно сделать выделение таба, которое с анимацией
   *        передвигается после выделения таба
   *
   * */
  function newTabs() {
    let tabs_active = "active",
      tabs_content = ".tabs__content";

    $("[data-tabs]").each(function () {
      $(this)
        .selectric({
          maxHeight: 200,
          disableOnMobile: false,
          nativeOnMobile: false,
          responsive: false,
          arrowButtonMarkup:
            '<b class="selectric__button icon-arrow-down"></b>',
        })
        .prop("selectedIndex", 0)
        .selectric("refresh")
        .on("change", function () {
          let tabs_parent = $(this).closest(".tabs__parent"),
            tabs_save = $(this).closest("[data-tabs-save]"),
            tabs_save_value = tabs_save.data("tabs-save"),
            tabs_selected = $(this)
              .parents(".selectric-wrapper")
              .find("li.selected"),
            tab_counter = tabs_selected.index();

          tabs_parent
            .find(tabs_content + ":first")
            .parent()
            .children(tabs_content)
            .removeClass(tabs_active)
            .eq(tab_counter)
            .addClass(tabs_active);

          // если указан дата аттрибут для сохранения - сохраняем его в localStorage
          if (tabs_save.length && tabs_save_value.length) {
            localStorage.setItem(tabs_save_value, tab_counter);
          }

          // синхронизация двух селектов
          // в случае сложной адаптивной структуры, если по дизайну селект (табы) переносятся в другой блок
          $("[data-tabs-sync]").each(function () {
            $(this)
              .parents(".selectric-wrapper")
              .find("li")
              .removeClass("selected")
              .eq(tab_counter)
              .addClass("selected")
              .trigger("click");
          });

          if ($(this).closest("[data-tabs-selector]").length) {
            // добавляем координаты и ширину для выделения
            $(this)
              .closest("[data-tabs-selector]")
              .parents(".selectric-wrapper")
              .find(".tabs__select")
              .css({
                left: tabs_selected.position().left + "px",
                width: tabs_selected.innerWidth() + "px",
              });
          }
        });

      if ($(this).closest("[data-tabs-selector]").length) {
        // создаём элемент, который будет использоваться как выделение
        let tabs_current = $(this)
          .parents(".selectric-wrapper")
          .find("li.selected");
        $(this)
          .parents(".selectric-wrapper")
          .find(".selectric-scroll")
          .prepend(
            '<span class="tabs__select" style="width: ' +
              tabs_current.innerWidth() +
              "px; left:" +
              tabs_current.position().left +
              'px"></span>'
          );
      }

      // находим общего родителя для табов и контена табов и проставляем классы
      let tabs_parent = $(
          $(this)
            .parents()
            .get()
            .find((itm) => $(itm).find(tabs_content).length)
        ),
        tabs_save = $(this).closest("[data-tabs-save]"),
        tabs_save_value = tabs_save.data("tabs-save");

      tabs_parent.addClass("tabs__parent");

      // если установлено сохранение активного таба - при загрузке страницы эмулируем клик на него
      if (tabs_save.length && tabs_save_value.length) {
        setTimeout(function () {
          tabs_save
            .parents(".selectric-wrapper")
            .find("li:eq(" + localStorage.getItem(tabs_save_value) + ")")
            .trigger("click");
        }, 1);
      }
    });
  }
  newTabs();

  // значение, при котором изменяется тип табов (табы или селект) задается в дата-аттрибут data-tabs-transform
  function tabsTypeCheck() {
    $("[data-tabs-transform]").each(function () {
      let windowWidth = $(this).data("tabs-transform");
      if (WIN.width() <= windowWidth) {
        $(this)
          .parents(".select")
          .removeClass("select--tabs")
          .addClass("select--transformed");
      } else {
        $(this)
          .parents(".select")
          .addClass("select--tabs")
          .removeClass("select--transformed");
      }
    });
  }
  tabsTypeCheck();

  WIN.on("resize", function () {
    // проверка типа табов
    tabsTypeCheck();
  });

  /** End New tabs **/

  /**
   * Переключение пустой и заполненной страницы
   */
  DOC.on("change", "[data-page-switch]", function () {
    if ($(this).find("input").is(":checked")) {
      $(".pageSwitch--void").toggle();
      $(".pageSwitch--full").hide();
    } else {
      $(".pageSwitch--void").toggle();
      $(".pageSwitch--full").show();
    }
  });

  /** Инициализация вызова модалок в модалках **/
  $(document).on("click", "[data-modal-in-modal]", (e) => {
    e.preventDefault();
    let url = $(e.currentTarget).attr("href");

    if ($.magnificPopup.instance.isOpen) {
      $.magnificPopup.close();
    }

    setTimeout(() => {
      $.magnificPopup.open({
        items: {
          src: url,
        },
        type: "ajax",
        removalDelay: 300,
        closeOnBgClick: true,
        closeBtnInside: false,
        showCloseBtn: true,
        enableEscapeKey: false,
        mainClass: "user-navigation",
        callbacks: {
          parseAjax: function (mfpResponse) {
            mfpResponse.data =
              "<div class='wrapping'>" + mfpResponse.data + "</div>";
          },
          beforeOpen: function () {
            $("body").addClass("blur");
          },
          beforeClose: function () {
            $("body").removeClass("blur");
          },
        },
      });
    }, 700);
  });

  DOC.on("click", "[data-modal-simple]", (e) => {
    e.preventDefault();
    $.magnificPopup.close();
    let self = $(e.currentTarget);

    setTimeout(function () {
      $.magnificPopup.open({
        items: {
          src: self.attr("href"),
        },
        type: "ajax",
        removalDelay: 300,
        mainClass: "mfp-zoom-in",
        callbacks: {
          parseAjax: function (mfpResponse) {
            mfpResponse.data =
              "<div class='wrapping'>" + mfpResponse.data + "</div>";
          },
          ajaxContentAdded: function () {
            this.content;
          },
          beforeOpen: function () {
            $("body").addClass("blur");
          },
          beforeClose: function () {
            $("body").removeClass("blur");
          },
        },
      });
    }, 1000);
  });

  /** End Инициализация вызова модалок в модалках **/

  // /** Footer providers **/
  //
  // $('[data-providers-hide]').hide();
  //
  // $('[data-providers-show]').click(function() {
  //     $('[data-providers-list]').addClass('opened');
  //     $(this).hide();
  //     $('[data-providers-hide]').show();
  // });
  //
  // $('[data-providers-hide]').click(function() {
  //     $('[data-providers-list]').removeClass('opened');
  //     $(this).hide();
  //     $('[data-providers-show]').show();
  // });
  //
  // /** End **/
});
